import React, { useRef, useState, useEffect } from "react";
import "./Connected.css";

import tech from "./assets/safety.png";
import edu from "./assets/compliance.png";
import ware from "./assets/efficency.png";

import mech from "./assets/payroll.png";
import mech1 from "./assets/human.png";
import mech2 from "./assets/solutions.png";
import mech3 from "./assets/door.png";
import mech4 from "./assets/time.png";

const ConnectedSmarter = () => {
  const tabs = [
    { id: "hr", label: "Human Resources" },
    { id: "tos", label: "Terminal Operating Solutions" },
    { id: "das", label: "Door Access System" },
    { id: "tcs", label: "Time Clock System" },
    { id: "pay", label: "Payroll System" },
  ];

  const [topImages, setTopImages] = useState([
    { id: "eff", src: edu, label: "efficiency" },
    { id: "safe", src: ware, label: "safety" },
    { id: "comp", src: tech, label: "compliance" },
  ]);

  const cards = [
    {
      id: "hr",
      title: "Human Resources",
      description:
        "Empower your workforce with seamless HR management. Automate attendance tracking, performance monitoring, and leave management while keeping your people connected and engaged through a unified system.",
      image: mech,
    },
    {
      id: "tos",
      title: "Terminal Operating Solutions",
      description:
        "Enhance operational efficiency across terminals with real-time visibility, optimized workforce deployment, and data-driven insights that ensure smooth logistics and resource utilization.",
      image: mech1,
    },
    {
      id: "das",
      title: "Door Access System",
      description:
        "Secure your premises with intelligent door access control. Manage permissions, monitor entry logs, and integrate with employee databases for enhanced security and accountability.",
      image: mech2,
    },
    {
      id: "tcs",
      title: "Time Clock System",
      description:
        "Track employee attendance effortlessly with advanced time clock solutions. Reduce manual errors and ensure accurate payroll processing.",
      image: mech3,
    },
    {
      id: "pay",
      title: "Payroll System",
      description:
        "Simplify payroll management with automated calculations, compliance tracking, and timely disbursements.",
      image: mech4,
    },
  ];

  const cardRefs = useRef({});
  const [activeTab, setActiveTab] = useState("hr");

  useEffect(() => {
    const interval = setInterval(() => {
      setTopImages((prev) => {
        const [first, ...rest] = prev;
        return [...rest, first];
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const scrollToCard = (id) => {
    const offset = 68 + 120;
    const el = cardRefs.current[id];
    if (!el) return;

    const y = el.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  useEffect(() => {
    const offset = 68 + 120;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

        if (visible.length > 0) {
          setActiveTab(visible[0].target.dataset.id);
        }
      },
      {
        root: null,
        rootMargin: `-${offset}px 0px -50% 0px`,
        threshold: 0.1,
      },
    );

    cards.forEach((card) => {
      const el = cardRefs.current[card.id];
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [cards]);

  return (
    <>
      <div className="wrapper">
        <div className="text-section">
          <p className="section-tag">JIVIEWS Solutions</p>

          <h1 className="section-title">
            Smarter Workforce <br />
            Management — As It Should Be
          </h1>

          <p className="section-desc">
            As a global leader in Enterprise Workforce Planning and Management
            Software, we specialize in delivering intelligent, end-to-end
            solutions built for complex workforce environments.
          </p>
        </div>

        <div className="image-section">
          {topImages.map((img, i) => (
            <div
              key={img.id}
              className={`image-card ${i === 0 ? "large" : "small"}`}
            >
              <img src={img.src} alt={img.label} />
              {i === 0 && <p className="image-label">{img.label}</p>}
            </div>
          ))}
        </div>
      </div>

      <div className="sticky-tabs">
        <div className="tab-list">
          {tabs.map((tab) => (
            <div
              key={tab.id}
              className={`tab-item ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => scrollToCard(tab.id)}
            >
              {tab.label}
            </div>
          ))}
        </div>
      </div>

      <div className="cards-wrapper">
        {cards.map((card) => (
          <div
            key={card.id}
            data-id={card.id}
            ref={(el) => (cardRefs.current[card.id] = el)}
            className="scroll-card"
          >
            <div className="card-text">
              <h2>{card.title}</h2>
              <p>{card.description}</p>
            </div>

            <img src={card.image} alt={card.title} className="card-image" />
          </div>
        ))}
      </div>
    </>
  );
};

export default ConnectedSmarter;
